import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuardService } from './services/auth-guard.service'
import {
  NbAuthComponent,
  NbLogoutComponent,
} from '@nebular/auth';

import { LoginComponent } from './pages/auth/login/login.component'
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component'
import { RestorePasswordComponent } from './pages/auth/restore-password/restore-password.component'

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'login',
        redirectTo: '',
      },
      {
        path: 'sign-up',
        component: SignUpComponent,
      },
      {
        path: 'sign-up',
        component: SignUpComponent,
      },
      {
        path: 'restore-password',
        component: RestorePasswordComponent,
      },
    ],
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: '**', redirectTo: 'home' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
